var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.isAvatar)?_c('img',{attrs:{"src":_vm.url,"loading":"lazy"}}):_c('img',{attrs:{"src":require('@/assets/svg/avatar.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }